module.exports = __webpack_public_path__ + "static/media/03.08f48221.jpg";